// src/components/AmpaSponsor.js
import React from "react";
import "./AmpaSponsor.css";

import ampaLogo from "../images/sponsors/ampa-logo-dark-bg.webp";

const AMPA_URL = "https://ampa-ma.web.app";

// Text provided by AMPA ("AMPA - Sponsorship Rubrique VetEd Africa", EN version)
const AMPA_SECTIONS = [
  {
    heading: "About the association",
    paragraphs: [
      "The Moroccan Association of Avian Pathology (Association Marocaine de Pathologie Aviaire — AMPA) is Morocco’s national scientific body for poultry health, uniting veterinarians, academics, researchers, health authorities and industry professionals. It is affiliated with the World Veterinary Poultry Association (WVPA).",
      "Under Article 4 of its statutes, AMPA is a scientific and technical association with no political, trade-union or profit-making purpose, independent of any decision-making centre or interest group. Its bureau is elected by the general assembly and serves unpaid.",
    ],
  },
  {
    heading: "A commitment written into its statutes",
    paragraphs: [
      "For AMPA, supporting scientific events is a founding obligation binding on every bureau, not an occasional activity. Among the six aims set by Article 2 are to “promote and organise scientific and cultural activities”, to foster collaboration with national and international bodies in avian pathology, and to take part in debates on poultry farming. Sponsoring and organising scientific events is therefore a statutory duty, reported to the general assembly each year.",
    ],
  },
  {
    heading: "Role in the 2nd VetEd Africa Congress",
    paragraphs: [
      "AMPA is a sponsoring organization of the 2nd VetEd Africa Congress, hosted at IAV Hassan II in Rabat. Continuing veterinary education is the second of its six statutory missions, and the competence of future practitioners determines the quality of avian health surveillance in the field. A congress on veterinary education and the role of artificial intelligence therefore falls squarely within its mandate: the sponsorship applies Articles 2 and 10 of its statutes and was decided by its bureau.",
    ],
  },
  {
    heading: "Governance, independence and disclosure",
    paragraphs: [
      "AMPA’s support carries no editorial or commercial condition: as an independent association with an unpaid bureau, it has no commercial interest to advance through the congress programme.",
      "For full transparency, three AMPA bureau members also serve on the congress’s organising bodies: Dr Noursaid Tligui (AMPA Treasurer General; President of the Congress Executive Committee), Dr Siham Fellahi (AMPA Secretary General; Scientific Committee) and Dr Charifa Drissi Touzani (AMPA Assessor; Scientific Committee). This overlap reflects the size of Morocco’s avian and veterinary academic community and is disclosed as a matter of public record.",
    ],
  },
];

const AmpaSponsor = () => {
  return (
    <section id="ampa" className="ampa-rubrique" aria-labelledby="ampa-title">
      <div className="ampa-card">
        <header className="ampa-header">
          <img
            src={ampaLogo}
            alt="Association Marocaine de Pathologie Aviaire (AMPA)"
            className="ampa-logo"
          />
          <div className="ampa-heading">
            <h2 id="ampa-title" className="ampa-name">
              Moroccan Association of Avian Pathology (AMPA)
            </h2>
            <p className="ampa-subtitle">
              Sponsoring Organization — 2nd VetEd Africa Congress
            </p>
          </div>
        </header>

        <div className="ampa-body">
          {AMPA_SECTIONS.map((section) => (
            <div key={section.heading} className="ampa-block">
              <h3>{section.heading}</h3>
              {section.paragraphs.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          ))}
        </div>

        <div className="ampa-actions">
          <a
            href={AMPA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ampa-link"
          >
            Visit the AMPA website
          </a>
        </div>
      </div>
    </section>
  );
};

export default AmpaSponsor;
